import React from 'react';
import Layout from '../components/App/Layout';
import Navbar from '../components/App/Navbar';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';

const PrivacyPolicy = () => {
  return (
    <Layout title="Privacy Policy">
      <Navbar />
      <PageBanner
        pageTitle="Privacy Policy"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Privacy Policy"
      />
      <div className="ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="privacy-policy-content" style={{ lineHeight: '1.8', color: '#4a4a4a' }}>
                <p style={{ color: '#777', marginBottom: '40px' }}>
                  <em>Last updated: September 29, 2026</em>
                </p>

                <p>
                  ByteForge (Pvt) Ltd ("ByteForge", "we", "our", or "us"), registered at 31-Q, Johar Town, Lahore, Pakistan, is committed to protecting your privacy. This Privacy
                  Policy explains how we collect, use, disclose, and safeguard your information when you visit
                  our website or engage our services. Please read this policy carefully.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>1. Information We Collect</h3>
                <p>
                  We may collect the following types of information:
                </p>
                <p>
                  <strong>Personal Information:</strong> Name, email address, phone number, company name, and
                  any other information you voluntarily provide when contacting us, submitting a form, or
                  entering into a service agreement.
                </p>
                <p>
                  <strong>Usage Data:</strong> Information about how you interact with our website, including
                  IP address, browser type, pages visited, time and date of visits, and referring URLs.
                  This data is collected automatically through cookies and analytics tools.
                </p>
                <p>
                  <strong>Communications Data:</strong> Records of correspondence when you communicate with
                  us via email, phone, WhatsApp, or any other channel.
                </p>
                <p>
                  <strong>Project Data:</strong> Information, documents, or materials you share with us as
                  part of a consultancy engagement.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>2. How We Use Your Information</h3>
                <p>
                  We use the information we collect for the following purposes:
                </p>
                <p>
                  To provide, deliver, and manage the services you have requested; to respond to inquiries,
                  proposals, and communications; to send project updates, invoices, and operational notices;
                  to improve our website, services, and internal processes; to comply with legal and regulatory
                  obligations; to protect the rights, property, or safety of ByteForge, our clients, or
                  the public; and to send marketing communications where you have given consent or where
                  we have a legitimate interest to do so.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>3. Legal Basis for Processing</h3>
                <p>
                  We process your personal data on the following legal bases: performance of a contract
                  (where processing is necessary to deliver our services); legitimate interests (such as
                  improving our services or communicating with prospects); legal obligation (where required
                  by applicable law); and consent (where you have explicitly agreed to specific processing,
                  such as receiving marketing emails).
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>4. Cookies and Tracking Technologies</h3>
                <p>
                  Our website uses cookies and similar tracking technologies to enhance your browsing
                  experience and gather analytics data. You may control cookie preferences through your
                  browser settings. Disabling cookies may affect certain functionality of our website.
                  We use analytics tools (such as Google Analytics) to understand site traffic and user
                  behaviour. These tools may set their own cookies subject to their respective privacy policies.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>5. Data Sharing and Disclosure</h3>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share
                  your information with trusted service providers who assist us in operating our website or
                  delivering services (e.g., cloud hosting providers, analytics platforms, payment processors),
                  subject to confidentiality agreements. We may also disclose information where required by
                  law, court order, or governmental authority.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>6. International Data Transfers</h3>
                <p>
                  ByteForge operates internationally and your data may be processed or stored in countries
                  outside your home jurisdiction, including Pakistan and the USA (where some of our service
                  providers operate). We take appropriate safeguards to ensure your data is protected in
                  accordance with the laws of Pakistan, including the Prevention of Electronic Crimes Act, 2016,
                  the Electronic Transactions Ordinance, 2002, and any personal data protection legislation
                  enacted in Pakistan from time to time.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>7. Data Retention</h3>
                <p>
                  We retain your personal data for as long as necessary to fulfil the purposes outlined in
                  this policy, satisfy our legal obligations, resolve disputes, and enforce our agreements.
                  Client project data is typically retained for a minimum of five (5) years following
                  project completion, unless a different period is agreed in writing.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>8. Your Rights</h3>
                <p>
                  Depending on your location and applicable law, you may have the right to access the
                  personal data we hold about you; request correction of inaccurate data; request deletion
                  of your personal data; object to or restrict certain processing activities; withdraw
                  consent at any time where processing is based on consent; and lodge a complaint with a
                  competent authority in Pakistan.
                </p>
                <p>
                  To exercise any of these rights, please contact us at{' '}
                  <a href="mailto:hello@byteforge.studio">hello@byteforge.studio</a>. We will respond within
                  thirty (30) days.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>9. Data Security</h3>
                <p>
                  We implement appropriate technical and organisational measures to protect your personal
                  data against unauthorised access, alteration, disclosure, or destruction. However, no
                  method of transmission over the internet is completely secure, and we cannot guarantee
                  absolute security.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>10. Third-Party Links</h3>
                <p>
                  Our website may contain links to third-party websites. We are not responsible for the
                  privacy practices or content of those sites. We encourage you to review the privacy
                  policies of any external sites you visit.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>11. Changes to This Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of significant
                  changes by posting the updated policy on our website with a revised "Last updated" date.
                  Your continued use of our website or services after any changes constitutes acceptance
                  of the updated policy.
                </p>

                <h3 style={{ marginTop: '40px', marginBottom: '15px' }}>12. Contact Us</h3>
                <p>
                  If you have any questions or concerns about this Privacy Policy or our data practices,
                  please contact us:
                </p>
                <p>
                  <strong>ByteForge (Pvt) Ltd</strong><br />
                  31-Q, Johar Town, Lahore, Pakistan<br />
                  Email: <a href="mailto:hello@byteforge.studio">hello@byteforge.studio</a><br />
                  WhatsApp: <a href="https://wa.me/923043545344">+92 304 3545344</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default PrivacyPolicy;
